module.exports = __webpack_public_path__ + "img/even.1e80d5e9.svg";